import growl from './growl';
import _ from 'lodash';
import CartService from './cart-service';

export default {
		addStickyClass,
		getCategoriesCarts,
		canAutoDeselectCompos,
		allMinOptionsTaken,
		initJoinOptions,
		getOptionCarts,
		sumChoicesTaken,
		allItemsTakenDesc,
		getMissingRequiredItems,
	};

	function getMissingRequiredItems(cartItem) {
		let missing = {
			MenuCategoryItems: [],
			OptionGroups: [],
		}
		for(let i in cartItem.product.categories) {
			let cat = cartItem.product.categories[i];
			let min = cat.MinChoicesNumber;
			let menuItem = _.find(cartItem.MenuItems,(menuItem) => menuItem.MenuCategoryId == cat.MenuCategoryId);
			let taken = 0;
			if (menuItem) {
				taken = _.sumBy(menuItem.MenuCategoryItems,'qty');
			}
			if (taken < min) {
				missing.MenuCategoryItems.push({
					category: cat,
					taken: taken,
					min: min,
				});
			}
		}
		for (let j in cartItem.OptionGroups) {
			let optionGroup = cartItem.OptionGroups[j];
			let min2 = optionGroup.minChoices;
			let takenChoices = optionGroup.numChoicesTaken;
			if (takenChoices < min2) {
				missing.OptionGroups.push({
					optionGroup: optionGroup,
					taken: takenChoices,
					min: min2,
				})
			}
		}

		return missing;
	}

	function allMinOptionsTaken(join_options) {
		return _.every(join_options, (option) => option.numChoicesTaken >= option.minChoices)
	}

	function canAutoDeselectCompos(cart) {
		for(let i in cart) {
			let compo = cart[i];
			console.log(compo);
			if (compo.product.options.length) {
				return false;
			}
		}
		return true;
	}

	function addStickyClass(stickyEl, marginTop = 0) {
		let el = stickyEl;
		let top = el.parent().parent()[0].getBoundingClientRect().top;
		var scTabMob = $(document).width() < 768;
		// console.log('parent top',top)
		if (top <= marginTop) {
			el.css('position','relative');
			if (scTabMob) {
				el.css('top',-top);
			} else {
				el.css('top',-top + marginTop);
			}
			el.addClass('sticked');
		} else {
			el.css('position','static');
			el.removeClass('sticked');
		}
	}

	function getCategoriesCarts(categories, cartItem) {
		let categoriesCarts = {};
		for(let i in categories) {
			categoriesCarts[categories[i].MenuCategoryId] = initCategoryCart(categories[i], cartItem);
		}
		return categoriesCarts;
	}

	function initCategoryCart(category, cartItem) {
		let cartMenuCategory = _.find(cartItem.MenuItems,
			(menuItem) => menuItem.MenuCategoryId == category.MenuCategoryId);
		if (!cartMenuCategory) {
			cartMenuCategory = {
				MenuCategoryId: category.MenuCategoryId,
				MenuId: category.pId,
				ChoicesNumber: category.ChoicesNumber,
				MinChoicesNumber: category.MinChoicesNumber,
				DefaultName: category.DefaultName,
				MenuCategoryItems: [],
			}
			cartItem.MenuItems.push(cartMenuCategory);
		}
		return cartMenuCategory.MenuCategoryItems;
	}

	function initJoinOptions(join_options, optionGroups, products, joinPrices) {
		let response = [];
		for(let i in join_options) {
			let option = _.clone(join_options[i]);
			option.index = i;
			option.optionGroup = optionGroups[option.OptionGroupId];
			option.allowQty = option.optionGroup.qty;
			option.maxChoices = option.max != -1 ? option.max : (option.optionGroup.max || -1);
			option.minChoices = option.min != -1 ? option.min : (option.optionGroup.min || -1);
			if (option.minChoices == -1) {
				option.minChoices = 0;
			}
			option.numChoicesTaken = 0;
			option.Options = {};
			response[i] = option;
		}
		return response;
	}

	function getOptionCarts(join_options, cartItem, products) {
		// let optionCarts = {};
		let optionCarts = [];
		for(let i in join_options) {
			let option = join_options[i];
			// let key = option.OptionGroupId;
			let key = option.index;
			if (!cartItem.OptionGroups[key]) {
				// cartItem.OptionGroups[key] = _.assign({ Options: {} }, option);
				cartItem.OptionGroups[key] = option;
			}
			optionCarts[key] = cartItem.OptionGroups[key].Options;
			initOptionChoicesForCart(optionCarts[key], option, products, cartItem.joinPrices);
		}
		return optionCarts;
	}

	function initOptionChoicesForCart(cartOption, option, products, joinPrices) {
		for(let j in option.optionGroup.choices) {
			let productId = option.optionGroup.choices[j];
			let product = products[productId];
			if (!product) {
				continue;
			}
			let price = CartService.getPrice(product, null, joinPrices, true);
			if (product.av) {
				CartService.addToCart(cartOption, { product, price, qty: 0 }, productId);
			}
		}
	}

	function sumChoicesTaken(join_option, optionCarts) {
		// let sum = 0, cartChoices = optionCarts[join_option.OptionGroupId];
		let sum = 0, cartChoices = optionCarts[join_option.index];
		for(let i in cartChoices) {
			sum += cartChoices[i].qty;
		}
		return sum;
	}

	function clearChoicesTaken(join_option, optionCarts) {
		let sum = 0, cartChoices = optionCarts[join_option.index];
		for(let i in cartChoices) {
			cartChoices[i].qty = 0;
		}
	}

	function allItemsTakenDesc(cartItems) {
		let descs = [];
		for(let i in cartItems) {
			for(let j in cartItems[i]) {
				let choice = cartItems[i][j];
				if (choice.qty) {
					let desc = choice.product.dn;
					if (choice.qty > 1) {
						desc = `${choice.qty} ${choice.product.dn}`;
						if (!choice.product.dn.endsWith('s')) {
							desc += 's';
						}
					}
					descs.push(desc);
				}
			}
		}
		return descs.join(' + ');
	}
